import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * On a genuine browser refresh (F5 / reload), send the user to the home page.
 *
 * IMPORTANT: the check must run only ONCE per real page load. In some versions
 * of React Router the `navigate` function changes identity on every navigation,
 * which would re-run this effect on each menu click — and since the page's
 * navigation type stays "reload" for the whole session, that would bounce every
 * click back to Home. The module-level `handled` flag below guarantees the
 * redirect logic runs a single time per document load (a full reload resets it),
 * so normal in-app navigation is never affected.
 */
let handled = false;

export default function ResetToHomeOnReload() {
  const navigate = useNavigate();

  useEffect(() => {
    if (handled) return; // already decided for this page load — never interfere with clicks
    handled = true;

    let navType = "navigate";
    const entries = performance.getEntriesByType("navigation");
    if (entries && entries.length > 0) {
      navType = entries[0].type; // "navigate" | "reload" | "back_forward"
    } else if (performance.navigation) {
      navType = performance.navigation.type === 1 ? "reload" : "navigate";
    }

    if (navType === "reload" && window.location.pathname !== "/") {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return null;
}